import {
    Button,
    LabeledButton,
    LabeledButtonContent,
    LabeledButtonLabel,
} from "@babackapp/customer-ui/components/button";
import {
    Header,
    HeaderDescription,
    HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import {
    InputGroup,
    InputGroupAddon,
    InputGroupInput,
    InputGroupText,
} from "@babackapp/customer-ui/components/input-group";
import { CustomerUiProvider } from "@babackapp/customer-ui/components/provider";

import { NumberInput } from "@babackapp/customer-ui/components/number-input";

import {
    Article,
    ArticleAction,
    ArticleFooter,
    ArticleImage,
    ArticleImagesStack,
    ArticleList,
    ArticlesGroup,
    ArticlesGroupAction,
    ArticlesGroupContent,
    ArticlesGroupSubtitle,
    ArticlesGroupTitle,
    ArticleSubtitle,
    ArticleTitle,
} from "@babackapp/customer-ui/components/article";

import {
    Option,
    OptionContent,
    OptionDescription,
    OptionIcon,
    OptionsList,
    OptionTitle,
} from "@babackapp/customer-ui/components/option";

import {
    Alert,
    AlertDescription,
    AlertTitle,
} from "@babackapp/customer-ui/components/alert";
import {
    DropdownMenu,
    DropdownMenuTrigger,
} from "@babackapp/customer-ui/components/dropdown-menu";
import {
    Stepper,
    StepperDivider,
    StepperHighlight,
    StepperItem,
} from "@babackapp/customer-ui/components/stepper";
import {
    Archive,
    BoxIcon,
    ChevronRight,
    ChevronsUpDown,
    ExternalLink,
    InfoIcon,
    PlusCircle,
    SettingsIcon,
    StoreIcon,
    VanIcon,
    WalletIcon,
} from "lucide-react";
import { RefundTypeSelect } from "./components/refund-type-select";

import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@babackapp/customer-ui/components/tooltip";
import { useState } from "react";

export default function CustomerUiDemoPage() {
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <TooltipProvider>
      <CustomerUiProvider className="min-h-screen w-screen p-8 bg-white flex flex-col justify-center items-center gap-16">
        <div className="w-[500px] flex flex-col justify-center items-center gap-10">
          <Stepper>
            <StepperItem
              onClick={() => setCurrentStep(0)}
              state={
                currentStep === 0
                  ? "present"
                  : currentStep > 0
                    ? "past"
                    : "future"
              }
            >
              {currentStep === 0 && <StepperHighlight />}
              <InfoIcon />
              <span>Raison</span>
            </StepperItem>
            <StepperDivider />
            <StepperItem
              onClick={() => setCurrentStep(1)}
              state={
                currentStep === 1
                  ? "present"
                  : currentStep > 1
                    ? "past"
                    : "future"
              }
            >
              {currentStep === 1 && <StepperHighlight />}
              <WalletIcon />
              <span>Resolution</span>
            </StepperItem>
            <StepperDivider />
            <StepperItem
              onClick={() => setCurrentStep(2)}
              state={
                currentStep === 2
                  ? "present"
                  : currentStep > 2
                    ? "past"
                    : "future"
              }
            >
              {currentStep === 2 && <StepperHighlight />}
              <SettingsIcon />
              <span>Config</span>
            </StepperItem>
          </Stepper>

          <Header>
            <HeaderTitle>Que voulez-vous retourner ?</HeaderTitle>
            <HeaderDescription>
              Séléctionnez les articles que vous souhaitez ajouter à votre
              demande de retour
            </HeaderDescription>
          </Header>

          <ArticlesGroup className="cursor-pointer">
            <ArticlesGroupContent>
              <ArticleImagesStack
                srcs={[
                  "https://www.wellowbabies.fr/cdn/shop/files/Capture_d_ecran_2024-04-05_a_10.30.08.png?v=1712305926&width=3840",
                  "https://www.wellowbabies.fr/cdn/shop/files/Capture_d_ecran_2024-04-05_a_10.30.08.png?v=1712305926&width=3840",
                  "https://www.wellowbabies.fr/cdn/shop/files/Capture_d_ecran_2024-04-05_a_10.36.19.png?v=1712306515&width=3840",
                ]}
              />
              <ArticlesGroupTitle>
                Commande du 18 Février #GB-0832
              </ArticlesGroupTitle>
              <ArticlesGroupSubtitle>
                3 Articles, total de 45€. Pantalon noir x1, Pantalon rouge x1,
                et 1 autre.
              </ArticlesGroupSubtitle>
              <ArticlesGroupAction>
                <ExternalLink />
              </ArticlesGroupAction>
            </ArticlesGroupContent>
          </ArticlesGroup>

          <ArticleList>
            <Article>
              <ArticleImage src="https://www.wellowbabies.fr/cdn/shop/files/6816d5ff-6fd5-47a6-80ca-front.webp?v=1709646054&width=750" />
              <ArticleTitle>Pull Col roulé</ArticleTitle>
              <ArticleSubtitle>Size: M | Color: Noir</ArticleSubtitle>
              <ArticleFooter>60.20€ • 30.10€ each</ArticleFooter>
              <ArticleAction>
                <Tooltip>
                  <TooltipTrigger>
                    <NumberInput />
                  </TooltipTrigger>
                  <TooltipContent>Quantité à retourner</TooltipContent>
                </Tooltip>
                <Button size="sm">
                  Retour
                  <ChevronRight />
                </Button>
              </ArticleAction>
            </Article>
            <Article>
              <ArticleImage src="https://www.wellowbabies.fr/cdn/shop/files/6816d5ff-6fd5-47a6-80ca-front.webp?v=1709646054&width=750" />
              <ArticleTitle>Pull Col roulé</ArticleTitle>
              <ArticleSubtitle>Qty: 1 | Size: M | Color: Noir</ArticleSubtitle>
              <ArticleAction>
                <Button size="sm">
                  Retour
                  <ChevronRight />
                </Button>
              </ArticleAction>
            </Article>
            <Article>
              <ArticleImage src="https://www.wellowbabies.fr/cdn/shop/files/6816d5ff-6fd5-47a6-80ca-front.webp?v=1709646054&width=750" />
              <ArticleTitle>Pull Col roulé</ArticleTitle>
              <ArticleSubtitle>Qty: 1 | Size: M | Color: Noir</ArticleSubtitle>
              <ArticleAction>
                <Button size="sm">
                  Retour
                  <ChevronRight />
                </Button>
              </ArticleAction>
            </Article>
          </ArticleList>

          <RefundTypeSelect />

          <OptionsList>
            <Option>
              <OptionIcon>
                <StoreIcon />
              </OptionIcon>
              <OptionTitle>Boutique de retour</OptionTitle>
              <OptionDescription>
                Vous pouvez retourner votre article dans n'importe quelle
                boutique physique de notre réseau. Sélectionnez une boutique
                pour obtenir l'adresse et les horaires d'ouverture.
              </OptionDescription>
              <OptionContent>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild className="w-full">
                    <LabeledButton variant="outline">
                      <LabeledButtonLabel>
                        Boutique de retour
                      </LabeledButtonLabel>
                      <LabeledButtonContent>
                        Aucune boutique sélectionnée
                      </LabeledButtonContent>
                      <ChevronsUpDown />
                    </LabeledButton>
                  </DropdownMenuTrigger>
                </DropdownMenu>
              </OptionContent>
            </Option>
          </OptionsList>

          <Alert variant="destructive">
            <Archive />
            <AlertTitle>Commande non trouvée</AlertTitle>
            <AlertDescription>
              Nous n'avons pas pu trouver de commande correspondant à ce numéro.
              Veuillez vérifier le numéro de commande et réessayer. Si le
              problème persiste, contactez notre support client pour obtenir de
              l'aide.
            </AlertDescription>
          </Alert>

          <Alert variant="pending">
            <VanIcon />
            <AlertTitle>Retard de livraison prévu</AlertTitle>
            <AlertDescription>
              Votre commande est actuellement en cours de livraison. Vous
              devriez la recevoir d'ici 3 à 5 jours ouvrables. Vous pouvez
              suivre l'état de votre livraison dans votre compte ou contacter
              notre support client pour plus d'informations.
            </AlertDescription>
          </Alert>

          <InputGroup className="h-auto">
            <InputGroupInput
              id="block-start-input"
              placeholder="Enter your name"
            />
            <InputGroupAddon align="block-start">
              <InputGroupText>Numéro de commande</InputGroupText>
              <BoxIcon />
            </InputGroupAddon>
          </InputGroup>

          <Button>
            <PlusCircle />
            Dépenser
          </Button>
        </div>
      </CustomerUiProvider>
    </TooltipProvider>
  );
}
